import { Controller } from "@hotwired/stimulus"
import { setUserPref } from "user_prefs"

// Dark / Light mode toggle. The HTML root class is set by an inline
// boot script in the layout (so the page paints in the right mode
// before this JS runs — no flash of white on dark). On click we flip
// the class, mirror to localStorage for the boot script, and PATCH
// /api/preferences so the choice follows the user across devices.

const SUN_ICON  = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>`
const MOON_ICON = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>`
const STORAGE_KEY = "pcp_dark_mode"

export default class extends Controller {
  static targets = ["icon", "label"]

  connect() {
    this._paint()
  }

  toggle(event) {
    event?.preventDefault?.()
    const next = !this._isDark()
    document.documentElement.classList.toggle("dark", next)
    try { localStorage.setItem(STORAGE_KEY, next ? "1" : "0") } catch (_) {}
    setUserPref("dark_mode", next)
    this._paint()
  }

  _isDark() {
    return document.documentElement.classList.contains("dark")
  }

  _paint() {
    const dark = this._isDark()
    if (this.hasIconTarget)  this.iconTarget.innerHTML  = dark ? SUN_ICON : MOON_ICON
    if (this.hasLabelTarget) this.labelTarget.textContent = dark ? "Light mode" : "Dark mode"
  }
}
